<template>
  <div class="content-wrapper" style=''>
    <div class="container-lg">
      <div class="row mb-12">
        <div class="col">
          <div class="page-title-nav row">
            <div class="col-2 col-lg-3">
              <router-link :to="`/lottoRecordList`" class="btn btn-outline-secondary btn-custom btn-back">
                <i class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                  class="d-none d-lg-block ms-2">ย้อนกลับ</span>
              </router-link>
            </div>
            <div class="col-8 col-lg-6">
              <h1 class="page-title">รายละเอียดโพย</h1>
            </div>
            <div class="col-12 col-lg-3">
              <a href="#" class="btn btn-primary btn-custom d-none"><i
                  class="fa-icon fa-regular fa-home"></i><span>button</span></a>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="content-card border-primary">
            <div class="content-card-title d-flex justify-content-between flex-wrap gap-2">
              <div class="col">
                โพยเลขที่ #{{ item.TicketId }}
              </div>
              <div class="col text-end">
                <button v-b-modal="'cancelPoyModal_'" class="btn btn-sm btn-outline-danger" style="text-decoration: none;"
                  target="_blank" v-if="getCanShowReturnBtn()">คืนโพย
                </button>
              </div>
            </div>
            <div class="content-card-body ">
              <div class="row border-bottom d-flex justify-content-between">
                <div class="col">
                  {{ item.title }}
                </div>
                <div class="col text-end">
                  <small class="mr-1">ทำรายการเมื่อ</small>
                  <span class="badge text-dark"><i class="far fa-calendar-alt"></i> {{
                    getDate(item.dateBetting) }}</span>
                  <span class="badge text-dark"><i class="far fa-clock"></i> {{
                    getTime(item.dateBetting) }} </span>
                </div>
              </div>
              <div class="row pt-3">
                <div class="col px-0">
                  <div class="pl-1 pr-0 text-center w-100">
                    <small>ยอดแทง</small>
                    <br>
                    <font class="fs-2 font-weight-light text-primary thb">฿ {{ item.price ? numberWithCommas(item.price) : '' }}</font>
                  </div>
                </div>
                <div class="col px-0">
                  <div class="pl-1 pr-0 text-center w-100">
                    <small>ผลได้เสีย</small>
                    <br>
                    <font class="fs-2 font-weight-light text-primary thb">฿ {{
                      numberWithCommas(item.WinAmount) }}</font>
                  </div>
                </div>
              </div>
              <hr>
              <div class="row">
                <template v-for="(itemList, index) in data_list">
                  <div :key="index" class="col-lg-4 col-12 col-md-4">
                    <div class=" p-0 table-active poy-content active">
                      <div class="card border-primary mb-3 ">
                        <div class="card-header p-0 card-header-border" style="">
                          <div class="poy-list-head">
                            <small>ลำดับ {{ index + 1 }}</small>
                            <span>#{{ item.TicketId }}</span>&nbsp;
                            <div class="poy-status notyet" v-if="item.status == 0 || item.status == 1">
                              {{ item.statusName }}
                            </div>
                            <div class="poy-status" :class="item.status == 2 ? 'lost' : 'success'"
                              v-else-if="item.status == 2">
                              {{ item.statusName }}
                            </div>
                            <div class="poy-status" :class="itemList.reward > 0 ? 'success' : 'lost'" v-else>
                              {{ itemList.reward > 0 ? 'ถูกรางวัล' : 'ไม่ถูกรางวัล' }}
                            </div>
                          </div>
                        </div>
                        <!-- {{ type_list }}
                        <br>
                        type_index:  {{itemList.type_index  }}
                        <br> -->
                        <!-- ผลรางวัล{{ getResultLotto }} || {{ Number(getResultLotto.reward6) }} -->
                        <!-- <br> -->
                        <!-- {{ getResultLotto.reward2_d.split('').join(',') }} -->
                        <div class="card-body card-body-border text-primary p-0">
                          <div class="row">
                            <div class="col">
                              <div class="poy-list-content">
                                <div class="row">
                                  <div class="col-7 m-0 pl-2 pr-1">
                                    <div class="poy-type text-center">
                                      <h3 class="text-primary">{{ itemList.number
                                        }}</h3>
                                      <small>{{ type_list[itemList.type_index]
                                        }}</small>
                                    </div>
                                  </div>
                                  <div class="col m-0 pl-1 pr-3 pb-1 border-left">
                                    <div class="d-flex justify-content-between">
                                    </div>
                                    <div class="col m-0 pl-1 pr-3 pb-1 border-left">
                                      <div class="d-flex justify-content-between border-bottom">
                                        <small>เลขที่ออก</small>
                                        <span class="number-win">{{ getResultByType(Number(itemList.type_index))
                                          }}</span>
                                      </div>
                                      <div class="d-flex justify-content-between ">
                                        <small>ราคาจ่าย</small>
                                        <span class="number-win">฿ {{ itemList.pay }}</span>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card-footer p-0 card-footer-border" style="">

                          <div style="" class="px-2 d-flex justify-content-between">
                            <div class="row ">
                              <div class="col">
                                <small class="">ราคาแทง:</small>
                                <font class="thb fs-3" v-if="itemList">฿ {{ numberWithCommas(itemList.price) }}</font>
                                <font class="thb fs-3" v-else>฿ 0</font>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col ">
                                <small class="mr-2">ผลได้เสีย:</small>
                                <font class="thb fs-3" v-if="itemList">฿ {{ numberWithCommas(itemList.reward) }}</font>
                                <font class="thb fs-3" v-else>฿ 0</font>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">

      </div>
      <div class="push">
        <b-modal style="height: 100%;"
          v-bind="{ id: 'cancelPoyModal_', title: 'ข้อความแจ้งเตือน ' }" scrollable
          hide-footer size="xl">
          <div class="row">
            <div class="col-12">
              <p class="text-dark">คุณต้องการคืนโพยเลขที่ <font class="text-danger">#{{ item.TicketId }}</font> ใช่หรือไม่ ?</p>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12">
              <button v-on:click="$bvModal.hide('cancelPoyModal_')" type="button" class="btn btn-secondary btn-block"
              data-dismiss="modal">ไม่</button>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <button v-on:click="submitReturnTicket()" type="button"
              class="btn btn-danger btnconfirmdelete btn-block">คืนโพย</button>
            </div>
          </div>
        </b-modal>
        <!-- <div v-on:click="popupDialog()" class=""
          v-bind:class="{ display: show_dialog, fade: show_dialog, 'modal-backdrop': show_dialog }"></div>
        <div class="modal fade modal_confirm_delete " tabindex="-1" role="dialog" v-bind:class="{ show: show_dialog }">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title text-dark">ข้อความแจ้งเตือน</h5>
                <button v-on:click="popupDialog()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div class="modal-body">
                <p class="text-dark">คุณต้องการคืนโพยเลขที่ #{{ item.TicketId }} ใช่หรือไม่ ?</p>
                <br>
              </div>
              <div class="modal-footer bg-white">
                <button v-on:click="popupDialog()" type="button" class="btn btn-secondary"
                  data-dismiss="modal">ไม่</button>
                <button v-on:click="submitReturnTicket()" type="button"
                  class="btn btn-danger btnconfirmdelete">คืนโพย</button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<style>
/* .modal .fade .modal_confirm_delete .show{
  display: block !important;
} */
.content-wrapper{
  font-family: "IBM Plex Sans Thai", sans-serif !important;
}
.border-bottom {
  border-bottom-width: 2px;
  border-bottom-color: #3c3a3a;
  border-bottom-style: solid;
}

.btn-block {
  display: block !important;
  width: 100% !important;
}

.poy-list-content {
  background: white;
  padding: 5px 10px;
  color: #6c757d;
}

.poy-list-content .row .col .ribbon-lotto i {
  font-size: 14px !important;
}

.poy-list-content .row .col .ribbon-lotto {
  background: rgba(0, 0, 0, 0.3);
  height: 20px;
  width: auto;
  display: inline-block;
  position: absolute;
  color: #fff;
  line-height: 20px;
  padding: 0px 5px;
  margin-top: 5px;
  border-left: rgba(0, 0, 0, 0.3) 1px solid;
  font-size: 16px;
}

.poy-list-content .row .col .ribbon-lotto:after {
  content: "";
  position: absolute;
  display: block;
  bottom: 0;
  border: 10px solid rgba(0, 0, 0, 0.3);
  right: -10px;
  height: 20px;
  border-left-width: 0px;
  border-right-color: transparent;
  filter: drop-shadow(6px 6px 3px rgba(0, 0, 0, 0.04));
}

.card-header-border {
  border-style: solid !important;
  border-color: #75a0e1 !important;
  border-top-width: 2px;
  border-right-width: 2px;
  border-left-width: 2px;
}

.card-body-border {
  border-style: solid !important;
  border-color: #75a0e1 !important;
  border-width: 0px 2px 2px 2px;

}

.card-footer-border {
  border-style: solid !important;
  border-color: #75a0e1 !important;
  border-width: 0px 2px 2px 2px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.poy-list-head {
  width: 100%;
  min-height: 30px;
  line-height: 1;
  border-bottom: #75a0e1 2px solid;
  padding: 6px 10px 0px 10px;
  vertical-align: middle;
  background: #fff;
  overflow: hidden;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

}

.poy-government small,
.poy-thaistock small,
.poy-foreignstock small,
.poy-yeekee small {
  font-weight: normal !important;
}

.poy-type {
  font-weight: normal;
  font-size: 0.85rem;
  padding: 5px;
  border-radius: 3px;
  line-height: 1.2;
  text-align: right;
  background: #eee;
  color: #000;
}

.poy-type h3 {
  line-height: 1;
  margin-bottom: 0;
}

.number-win {
  color: cadetblue;
  font-size: 170%;
  line-height: 1;
}

.poy-government {
  background: #17a2b8;
}

.poy-thaistock {
  background: var(--color-1-main);
}

.poy-foreignstock {
  background: #6610f2;
}

.poy-yeekee {
  background: #dc3545;
}

.poy-list-head .poy-status {
  display: block;
  float: right;
  margin-top: -6px;
  margin-right: -10px;
  width: auto;
  min-height: 30px;
  /* box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    border: 4px solid rgba(255, 255, 255, 0.5); */
  color: #000;
  font-size: 80%;
  /* padding-top: 12px; */
  padding-top: 8px;
  overflow: hidden;
  padding-left: 5px;
  padding-right: 5px;
}

.poy-list-head .poy-status.notyet {
  background: #ffc107;
}

.poy-list-head .poy-status.success {
  background: #3ac028;
  color: white;
}

.poy-list-head .poy-status.win {
  background: #3ac028;
  color: white;
}

.poy-list-head .poy-status.lost {
  background: #dc3545;
  color: white;
}
</style>

<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { listAllBetHistoryService, listAllBetHistoryServiceById, returnBetServiceById } from '@/services'

export default {
  async created () {
    this.setLoading(true)
    const id = Number(this.$route.params.id)
    this.id = id
    setInterval(() => {
      this.getNow()
    }, 1000)
    this.poyId = this.$route.params.id
    this.callListAllBetHistoryService(this.id)
  },
  methods: {
    ...mapActions(['setLoading', 'fetchResultLotto', 'getInquiryRoundInfomationByID', 'getBalanceInfo']),
    async callListAllBetHistoryService (id) {
      const resp = await listAllBetHistoryService()
      if (resp.status_code === 'SUCCESS') {
        const data = resp.data.map(e => {
          return {
            ...e,
            numberbet: [],
            // numberbet: e.numberbet,
            WinAmount: parseInt(e.WinAmount),
            IsWinPrice: JSON.parse(e.IsWinPrice),
            dateBetting: moment(e.dateBetting)
          }
        })
        console.log(data)
        const dataTemp = data.find(e => Number(e.TicketId) === Number(id))
        if (dataTemp != null) {
          this.item = dataTemp
        }
        this.callListAllBetHistoryServiceById(this.id)
        this.setLoading(false)
      }
    },
    async callListAllBetHistoryServiceById (id) {
      const respById = await listAllBetHistoryServiceById(id)
      if (respById.status_code === 'SUCCESS') {
        this.data_list = respById.data.list
        this.sortByReward()
        this.type_list = respById.data.type_name
        this.lottery_id = respById.data.lottery_id
        await this.getInquiryRoundInfomationByID(this.lottery_id)
        await this.fetchResultLotto(this.lottery_id)
      }
    },
    getDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    getTime (date) {
      return moment(date).format('HH:mm:ss')
    },
    popupDialog () {
      this.show_dialog = !this.show_dialog
      // alert(this.show_dialog)
    },
    submitReturnTicket () {
      this.setLoading(true)
      this.callSubmitReturnTicket()
      this.$bvModal.hide('cancelPoyModal_')
    },
    sortByReward () {
      this.data_list.sort((a, b) => b.reward - a.reward)
    },
    async callSubmitReturnTicket () {
      if (this.enable_del_ticket) {
        this.enable_del_ticket = false
        const respById = await returnBetServiceById(this.item.TicketId)
        if (respById.status_code === 'SUCCESS') {
          const id = Number(this.$route.params.id)
          this.callListAllBetHistoryService(id)
          const respById = await listAllBetHistoryServiceById(id)
          if (respById.status_code === 'SUCCESS') {
            this.data_list = respById.data.list
            this.type_list = respById.data.type_name
            this.lottery_id = respById.data.lottery_id
            await this.getBalanceInfo()
          }
          this.setLoading(false)
          this.show_dialog = !this.show_dialog
          this.alertDisplay()
          this.enable_del_ticket = true
        } else {
          this.callListAllBetHistoryService(this.poyId)
          this.setLoading(false)
          this.show_dialog = !this.show_dialog
          this.enable_del_ticket = true
        }
      }
      await this.getInquiryRoundInfomationByID(this.lottery_id)
    },
    alertDisplay () {
      this.$swal({
        position: 'center',
        icon: 'success',
        title: 'คืนโพยสำเร็จ',
        showConfirmButton: false,
        timer: 1500
      })
    },
    getResultByType (indexType) {
      if (!Number(this.getResultLotto.reward6) > 0) {
        return '-'
      }
      if (this.getResultLotto != null) {
        if (indexType === 0 || indexType === 1) {
          return this.getResultLotto.reward6.substring(this.getResultLotto.reward6.length - 3, this.getResultLotto.reward6.length)
        } else if (indexType === 2) {
          return this.getResultLotto.reward3_f.join(',')
        } else if (indexType === 3) {
          return this.getResultLotto.reward3_d.join(',')
        } else if (indexType === 4) {
          return this.getResultLotto.reward6.substring(this.getResultLotto.reward6.length - 2, this.getResultLotto.reward6.length)
        } else if (indexType === 5) {
          return this.getResultLotto.reward2_d
        } else if (indexType === 6) {
          return this.getResultLotto.reward6.split('').join(',')
        } else if (indexType === 7) {
          return this.getResultLotto.reward2_d.split('').join(',')
        } else if (indexType === 8 || indexType === 9) {
          return this.getResultLotto.reward4
        }
      }
      return '-'
    },
    getIsClose (value) {
      const final = moment(value)
      const now = this.currentDate ? this.currentDate : ''
      const timeleft = final - now
      if (timeleft > 0) {
        return false
      } else {
        return true
      }
    },
    getNow () {
      this.currentDate = moment()
    },
    getCanShowReturnBtn () {
      let status = false
      if (Number(this.item.status) === 0) {
        if (!this.getIsClose(this.getInquiryRoundInfomation.date.date_close) && this.getInquiryRoundInfomation.date.date_close !== 0) {
          if (Number(this.getInquiryRoundInfomation.status) === 1) {
            status = true
          }
        }
      }
      return status
    },
    numberWithCommas (x) {
      return (x + '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  data () {
    return {
      show_dialog: false,
      type_list: [],
      data_list: [],
      poyId: 0,
      list: [],
      item: {},
      lottery_id: 0,
      currentDate: '',
      enable_del_ticket: true
    }
  },
  computed: {
    ...mapGetters(['getResultLotto', 'getInquiryRoundInfomation']),
    sortedByReward () {
      return [...this.data_list].sort((a, b) => b.reward - a.reward)
    }
  }
}
</script>
